export const ExpansionPanelSummaryStyles = {
  root: {
    height: '80px',
    border: 0,
    padding: 0,
    margin: 0,
    borderBottom: '2px solid #ececec',
    backgroundColor: '#fff',
    '&:hover': { background: '#f9f9f9' },
    '&$content': { margin: 0 },
  },
  content: {
    width: 'calc(100% - 60px)',
    margin: 0,
    minHeight: '80px',
  },
  expanded: {
    margin: 0,
  },
  expandIcon: {
    marginRight: '8px',
    marginLeft: '8px',
  },
};

export const ExpansionPanelStyles = {
  root: {
    border: 0,
  },
  expanded: {
    borderBottom: '2px solid #ececec',
  },
};

export const ExpansionPanelDetailsStyles = {
  root: {
    border: 0,
    padding: 0,
  },
};
